import ObjectTree from '@components/objectTree/ObjectTree';
import { useObjects } from '@hooks/useObjects';

import ObjectTreeCard from './ObjectTreeCard';

/**
 * The Objects page's taxonomy tree for one project type: the shared `ObjectTree`
 * shell with this page's data and its full-detail row card.
 */
const ObjectList = ({ mode, selectedUuid = null, onSelect, onEdit, onDelete }) => {
	const { tree, isLoading, isError } = useObjects(mode, { withCounts: true });

	const renderNode = node => (
		<ObjectTreeCard
			object={node}
			mode={mode}
			selected={node.uuid === selectedUuid}
			onEdit={onEdit}
			onDelete={onDelete}
		/>
	);

	return (
		<ObjectTree
			tree={tree}
			isLoading={isLoading}
			isError={isError}
			selectedUuid={selectedUuid}
			onSelect={onSelect}
			renderNode={renderNode}
		/>
	);
};

export default ObjectList;
